const types = {
  defaultType: 'defaultType',
  modalType: 'modalType',
};

export default types;
